<div class="flex" [style.min-width.px]="cellSize * 53 + 52 * 4 + (cellSize + 4)">
  <div
    class="flex-grow text-sm min-h-6 flex justify-center items-center"
    *ngFor="let month of Months; let i = index"
  >
    {{ month }}
  </div>
</div>
